import { createContext, useContext } from 'react'

interface CellContextValue {
  size: 'default' | 'compact' | null
}

const CellContext = createContext<CellContextValue | null>(null)

function useCellContext() {
  const context = useContext(CellContext)
  if (!context) {
    throw new Error('useCellContext must be used within Cell')
  }
  return context
}

export { CellContext, useCellContext }
